import React, {useEffect} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import BootstrapTable from 'react-bootstrap-table-next';

import "./index.scss"

import { dollarUS, formatDate } from '../../utilities/formatters';
import { getCommissionPayment } from '../../store/reducers/affiliateReducer';

const CommissionPayment = () => {

    const dispatch = useDispatch();
    const data = useSelector(state=>state.affiliate.commission_payment)

    useEffect(()=>{
        dispatch(getCommissionPayment())
    },[dispatch])

    const columns = [
      {
        dataField: "created_at",
        text: "Date",
        formatter: (cell, row, rowIndex)=>{
          return `${formatDate(new Date(cell))}`
        }
      },
      {
        dataField: "commission_percentage",
        text: "Commission Percentage"
      },
      {
        dataField: "amount",
        text: "Amount",
        formatter: (cell)=>{
          return (dollarUS(cell))
        }
      },
      {
        dataField: "status",
        text: "Status"
      }
    ];
    
  return (
    <div id="commission-payment-table">
      {data && Array.isArray(data) && data.length?<BootstrapTable keyField="id" data={data} columns={columns}/>:false}
    </div>
  )
}

export default CommissionPayment
